<template>
  <div class="mt-1 mr-1 mb-5" v-if="canVerb(resource, 'index')">
    <actions-toolbar>
      <template #filters>
        <div class="status-filter">
          <div class="pill-wrapper my-3">
            <span
              class="pill"
              v-for="(value, name, index) in activeFilters"
              :key="index"
              data-color="white"
            >
              <span v-b-toggle.sidebar-1 :data-filter="name"
                ><strong>{{ sidebarFilterName(name) }}</strong
                >:&nbsp;{{ sidebarFilterValue(name, value) }}</span
              >
              <span tabindex="0">
                <span
                  @click="resetSingleSidebarFilter(name)"
                  title="Rimuovi filtro"
                  >×</span
                >
              </span>
            </span>
            <template v-if="countActiveFilters">
              <span
                class="pill"
                data-color="alert"
                @click="resetAllFilters()"
                title="Rimuovi i filtri e apri il pannello per una nuova ricerca"
              >
                <span
                  ><strong>Reset ({{ countActiveFilters }})</strong></span
                >
                <span><span>×</span></span>
              </span>
            </template>
          </div>
        </div>
      </template>
      <b-button-group
        v-b-toggle.sidebar-1
        :class="`filter-button-group btn--smaller btn--transparent align-items-center gap-3${
          countActiveFilters ? ' active' : ''
        }`"
        :title="getDefaultFilterMessage()"
      >
        <base-icon name="filters" width="23" height="23" />
        <span style="font-size: 14px; font-weight: 500">{{
          computedFilterTitle
        }}</span>
      </b-button-group>
    </actions-toolbar>
    <div class="table-container">
      <b-sidebar
        id="sidebar-1"
        :title="computedFilterTitle"
        :backdrop="true"
        width="50dvw"
        shadow
        right
        :visible="open_filter"
        :data-open="open_filter"
        @change="onSidebarFilterChange"
      >
        <b-form @submit.prevent="onSearch(filterName)">
          <div class="filter">
            <div class="filter-item">
              <base-select
                name="cod_prod"
                label="Produttore"
                :options="salesmen_select"
                v-model="filter.byBroker.id"
                :multiple="true"
                :closeOnSelect="false"
                :taggable="salesmen_taggable"
                :defaultHtmlMultipleSelect="true"
                @changeTaggable="changeTaggable"
              >
                <template #advanced-actions>
                  <b-button
                    :pressed.sync="myToggle"
                    variant="light"
                    class="btn--smaller btn--x-smaller btn--transparent"
                    @click="
                      myToggle ? selectAllBrokers() : deselectAllBrokers()
                    "
                    >{{ myToggle ? "Deseleziona tutti" : "Seleziona tutti" }}
                  </b-button>
                  <b-button
                    :pressed.sync="myTogglePO"
                    variant="light"
                    class="btn--smaller btn--x-smaller btn--transparent"
                    @click="
                      myTogglePO ? salesmenOrderByCode() : salesmenOrderByName()
                    "
                    >{{ myTogglePO ? "Ordine per nome" : "Ordina per codice" }}
                  </b-button>
                </template>
              </base-select>
            </div>
            <div class="filter-item" data-cols="2">
              <base-datepicker
                name="from"
                label="Registrazione Dal"
                v-model="filter.byCalendar.from"
              />
              <base-datepicker
                name="to"
                label="Registrazione Al"
                v-model="filter.byCalendar.to"
              />
            </div>
            <div class="filter-item" data-cols="2">
              <base-datepicker
                name="iniziale_from"
                label="Data iniziale rendiconto dal"
                v-model="filter.byFrom.from"
              />
              <base-datepicker
                name="iniziale_to"
                label="Data iniziale rendiconto al"
                v-model="filter.byFrom.to"
              />
            </div>
            <div class="filter-item" data-cols="2">
              <base-datepicker
                name="finale_from"
                label="Data finale rendiconto dal"
                v-model="filter.byTo.from"
              />
              <base-datepicker
                name="finale_to"
                label="Data finale rendiconto al"
                v-model="filter.byTo.to"
              />
            </div>
            <div class="filter-item">
              <base-input
                name="id"
                label="ID Rendiconto"
                v-model="filter.byAttribute.id"
              />
            </div>
            <div class="filter-item" data-cols="2">
              <base-select
                name="collected"
                label="Incassato"
                v-model="filter.byAttribute.is_collected"
                :options="opt_incassato"
              />
              <base-select
                name="collected"
                label="Selezionato per l'invio"
                v-model="filter.byAttribute.is_selected"
                :options="[
                  { value: 'Y', text: 'Si' },
                  { value: 'N', text: 'No' },
                ]"
              />
            </div>
          </div>
          <div class="actions-filter-sidebar-wrapper">
            <b-button
              type="submit"
              variant="lisaweb"
              size="sm"
              v-b-toggle:sidebar-1
              >Cerca
            </b-button>
            <b-button
              class="btn--transparent btn-reset"
              type="button"
              size="sm"
              @click="onClearFilter(filterName)"
              >Reset
            </b-button>
          </div>
        </b-form>
      </b-sidebar>
      <b-overlay center :show="isLoading" rounded="sm">
        <div v-show="!isLoading">
          <broker-statements-accounting
            :filterOn="{
              byRelations: ['byBroker', 'byDocument'],
            }"
            @destroy="removeBrokerStatement"
            @report="downloadReport"
            :fields="flds"
            :repository="repository"
            :resource="resource"
            :filterName="filterName"
            :ref="tableRef"
            :onlyActions="['infomodal', 'destroy']"
            noPagination
            :loadingSpunte="isLoadingSpunte"
            :performedSearch="performedSearch"
            :filterCount="countActiveFilters"
            @selezionato="onUpdateSelected"
            @spunta="onSelectAll"
            @toglispunta="onUnselectAll"
            @spuntaunique="onUniqueSelectAll"
            @toglispuntaunique="onUniqueDeselectAll"
            @unique="onUnique"
          >
            <template #selection-actions="{ count }">
              <b-button
                type="button"
                variant="primary"
                class="btn-create btn--smaller"
                :disabled="isLoading || count === 0"
                @click="onOpenBrokerStatementModal"
                >Invia selezionati ({{ count }})
              </b-button>
            </template>
            <template #unique-actions="{ count }">
              <b-button
                type="button"
                variant="primary"
                class="btn-create btn--smaller"
                :disabled="isLoading || count === 0"
                @click="onGenerateUniquePdf"
                >Genera PDF ({{ count }})
              </b-button>
            </template>
          </broker-statements-accounting>
        </div>
        <broker-statement-modal
          :ref="modalRef"
          v-model="lscmnc"
          :options="email_templates"
          title="Stai per inviare via e-mail ai produttori tutti i rendiconti selezionati"
          @send="onSend"
        ></broker-statement-modal>
        <!-- <generate-broker-statements-modal
          :ref="generateBrokerStatementModalRef"
          :title="broker_statement_title"
          :header="broker_statement_header"
          @generate="onGenerate"
        ></generate-broker-statements-modal> -->
        <template #overlay>
          <div class="text-center">
            <div class="custom-loader"></div>
            <p class="loading-text">Operazione in corso...</p>
          </div>
        </template>
      </b-overlay>
    </div>
  </div>
</template>
<script>
import BaseIcon from "@/components/BaseIcon";
import BaseInput from "@/components/form/BaseInput";
import BrokerStatementsAccounting from "@/components/tables/BrokerStatementsAccounting";
import CustomFiltersMixin from "@/mixins/CustomFiltersMixin";
import ConfirmModalMixin from "@/mixins/ConfirmModalMixin";
import ExportsMixin from "@/mixins/ExportsMixin";
import DocumentsMixin from "@/mixins/DocumentsMixin";
import { mapGetters, mapActions } from "vuex";
import BrokerStatementModal from "@/components/modals/sendBrokerStatementModal";
import BaseSelect from "@/components/form/BaseSelect";
import BaseDatepicker from "@/components/form/BaseDatepicker";
import { toLocaleCurrency } from "@/utils/strings";
import { toLocaleDate } from "@/utils/dates";
import { RepositoryFactory } from "@/repositories/RepositoryFactory";
import { RepositoryFactory as RepositoryFactoryLC } from "@/repositories/lisacomunica/RepositoryFactory";
import { computed } from "vue";
import SidebarFilterMixin from "../../../../mixins/SidebarFilterMixin";

export default {
  mixins: [
    CustomFiltersMixin,
    ConfirmModalMixin,
    DocumentsMixin,
    ExportsMixin,
    SidebarFilterMixin,
  ],
  data() {
    return {
      isLoading: false,
      isSaving: false,
      isLoadingSpunte: false,
      performedSearch: false,
      filter: this.initFilter(),
      salesman_id: null,
      arretrati: null,
      myToggle: false,
      myTogglePO: false,
      salesmen_ordered: [],
      salesmen_select: [],
      salesmen_ids: [], // i produttori della tendina multipla
      calculus_type: 0, // TODO diventerà byQualcosa...
      showCollapse1: true,
      canShowBrokerStatement: false,
      changedIds: [],
      email_templates: [],
      opt_incassato: [
        { value: "Y", text: "Si" },
        { value: "N", text: "No" },
      ],
      activeFilters: {},
      // broker_statement_title: null,
      // broker_statement_header: null,
      // mode: null,
      uniquePdfIds: [],
      filterName: "filterBrokerStatementsAccounting",
      resource: "broker_statements",
      repository: "broker_statement",
      tableRef: "BrokerStatementsAccountingTableRef",
      modalRef: "sendBrokerStatementModal",
      // generateBrokerStatementModalRef: "generateBrokerStatementModal",
      form: {
        template_id: null, // per Lisacomunica...
      },
      fields: [],
      selectableFields: {
        N: [
          {
            key: "selezionato",
            label: "Sel.",
            sortable: false,
            thStyle: {
              width: "2px",
            },
          },
          {
            key: "id",
            label: "Id",
          },
          {
            key: "broker",
            label: "Produttore",
            sortable: true,
            sortKey: "byBroker.BUID",
          },
          {
            key: "created_date",
            label: "Data creazione",
            sortable: false,
            formatter: (value) => toLocaleDate(value),
          },
          {
            key: "from",
            label: "Data inizio",
            sortable: true,
            formatter: (value) => toLocaleDate(value),
            sortKey: "from",
          },
          {
            key: "to",
            label: "Data fine",
            sortable: true,
            formatter: (value) => toLocaleDate(value),
            sortKey: "to",
          },
          {
            key: "premium",
            label: "Totale da versare",
            sortable: true,
            formatter: (value) => toLocaleCurrency(parseFloat(value)),
            thClass: "text-right",
            thStyle: {
              "text-align": "right",
            },
            tdClass: "text-right",
          },
          {
            key: "totalizers",
            label: "Totalizzatori",
            thStyle: {
              "min-width": "200px",
              "padding-left": "25px",
            },
          },
          {
            key: "files",
            label: "File generati",
            thStyle: {
              "min-width": "200px",
            },
          },
          {
            // campo fittizio, solo lato client
            key: "uniquePdfRow",
            label: "Sel.Per.PDF",
            sortable: false,
            thClass: "check",
            tdClass: "text-center",
          },
        ],
        Y: [
          {
            key: "selezionato",
            label: "Sel.",
            sortable: false,
            thStyle: {
              width: "2px",
            },
          },
          {
            key: "rowSelector",
            label: "Dettagli",
            sortable: false,
            thStyle: {
              width: "2px",
            },
          },
          {
            key: "id",
            label: "Id",
          },
          {
            key: "broker",
            label: "Produttore",
            sortable: true,
            sortKey: "byBroker.BUID",
          },
          {
            key: "created_date",
            label: "Data creazione",
            sortable: false,
            formatter: (value) => toLocaleDate(value),
          },
          {
            key: "from",
            label: "Data inizio",
            sortable: true,
            formatter: (value) => toLocaleDate(value),
            sortKey: "from",
          },
          {
            key: "to",
            label: "Data fine",
            sortable: true,
            formatter: (value) => toLocaleDate(value),
            sortKey: "to",
          },
          {
            key: "is_collected.text",
            label: "Incassato",
            sortable: false,
          },
          {
            key: "premium",
            label: "Totale da versare",
            sortable: true,
            formatter: (value) => toLocaleCurrency(parseFloat(value)),
            thClass: "text-right",
            thStyle: {
              "text-align": "right",
            },
            tdClass: "text-right",
          },
          {
            key: "totalizers",
            label: "Totalizzatori",
            thStyle: {
              "min-width": "200px",
            },
          },
          {
            key: "files",
            label: "File generati",
            thStyle: {
              "min-width": "200px",
            },
          },
          {
            key: "uniquePdfRow",
            label: "Sel.PDF",
            sortable: false,
            thClass: "check",
            tdClass: "text-center",
          },
        ],
      },
      salesmen: [],
      salesmen_taggable: true,
    };
  },
  provide() {
    // use function syntax so that we can access `this`
    return {
      uniquePdfIdsLength: computed(() => this.uniquePdfIds.length),
    };
  },
  components: {
    BaseIcon,
    BaseInput,
    BaseSelect,
    BaseDatepicker,
    BrokerStatementsAccounting,
    BrokerStatementModal,
    // GenerateBrokerStatementsModal,
  },
  methods: {
    changeTaggable(val) {
      this.salesmen_taggable = val;
    },
    initFilter() {
      let init = {
        byBroker: {
          id: null,
        },
        byAttribute: {
          is_collected: null,
          is_selected: null,
          id: null,
        },
        byCalendar: {
          from: null,
          to: null,
        },
        byFrom: {
          // REVIEW: temporary name must be changed
          from: null,
          to: null,
        },
        byTo: {
          // REVIEW: temporary name must be changed
          from: null,
          to: null,
        },
      };
      return init;
    },
    onOpenBrokerStatementModal() {
      this.$bvModal.show(this.modalRef);
    },
    // onOpenGenerateBrokerStatements(mode) {
    //   switch (mode) {
    //     case "broker_statement_mode":
    //       this.broker_statement_header = "Genera Rendiconti";
    //       this.broker_statement_title =
    //         "Stai per generare i rendiconti dei produttori selezionati";
    //       this.mode = "broker_statement_mode";
    //       break;
    //     case "commission_mode":
    //       this.broker_statement_header = "Effettua Calcoli Provvigionali";
    //       this.broker_statement_title =
    //         "Stai per generare i calcoli provvigionali dei produttori selezionati";
    //       this.mode = "commission_mode";
    //       break;
    //   }
    //   this.$bvModal.show(this.generateBrokerStatementModalRef);
    // },
    // onOpenGenerateBrokerStatements() {
    //   this.$bvModal.show(this.generateBrokerStatementModalRef);
    // },
    // manipolaItems(data) {
    //   data.forEach((item) => {
    //     if (!item.selected) {
    //       item["selected"] = { text: "", value: null };
    //     }
    //     // if (item.users.length) {
    //     if (item.is_selected.value == "Y") {
    //       item.selected.value = "Y";
    //       item.selected.text = "Si";
    //     } else {
    //       item.selected.value = "N";
    //       item.selected.text = "No";
    //     }
    //   });
    //   return data;
    // },
    salesmenOrderByName() {
      this.salesmen_select = this.salesmen;
    },
    salesmenOrderByCode() {
      this.salesmen_select = this.salesmen_ordered;
    },
    selectAllBrokers() {
      this.filter.byBroker.id = this.getSalesmen().map(
        (cooperator) => cooperator.value,
      );
    },
    deselectAllBrokers() {
      this.filter.byBroker.id = [];
      this.salesman_id = null;
    },
    onSearch(name) {
      this.performedSearch = true;
      this.activeFilters = {};
      this.activeFilters = this.retriveActiveFilters();
      // if (
      //   !this.salesman_id ||
      //   !this.filter.byCalendar.from ||
      //   !this.filter.byCalendar.to
      // ) {
      //   let missing = {};
      //   missing.produttore = !this.salesman_id;
      //   missing.creazione_dal = !this.filter.byCalendar.from;
      //   missing.creazione_al = !this.filter.byCalendar.to;
      //   let msg = `Devi selezionare ${Object.keys(missing)
      //     .filter((key) => missing[key])
      //     .join(", ")}`;
      //   this.$showSnackbar({
      //     preset: "success",
      //     text: msg,
      //     showAction: false,
      //   });
      // } else {
      // some handles for the fetch call...
      let args = { items: { handle: null, params: [] }, verb: {} };
      // // 1. items handle (add fake field uniquePdfRow)
      args.items.handle = this.manipolaItems;
      // let previous = this.filter.byCalendar.from;
      // DEBUG
      // this.filter.bySalesman = {};
      // this.filter.bySalesman.id = this.salesman_id;

      let criteria = this.filter;
      // store the filter
      this.saveFilterByName({ name, criteria });

      // fetch data
      this.$refs[this.tableRef].fetch(args).then(() => {
        // // set summary.ritenuta_perc from first item's broker.attributables.WHT
        // if (this.$refs[this.tableRef].items.length) {
        //   // NOTE nel caso Calcola con Lisaweb, item non ha la proprietà "brokers", quindi metto a 0
        //   this.summary.ritenuta_perc = this.$refs[this.tableRef].items[0]
        //     .brokers
        //     ? this.$refs[this.tableRef].items[0].brokers[0].attributables.WHT
        //     : 0;
        // }
        // // setChangedIds
        // if (this.calculus_type == 1) {
        //   // if calculated value id different, then row must be updatable...
        //   this.setChangedIds(this.$refs[this.tableRef].items);
        // }
        // this.filter.byCalendar.from = previous;
        // this.resetPage();
        this.$refs[this.tableRef].loadSelectedCounter();
        // reset Sel.PDF checkbox
        this.$refs[this.tableRef].myToggleUnique = false;
        this.uniquePdfIds = [];
      });
      this.showCollapse1 = false;
      // }
    },
    onClearFilter(name) {
      // this.$nextTick(() => {
      this.resetFilter();
      // reset salesman_id
      this.salesman_id = null;
      // reset arretrati
      this.arretrati = false;
      this.resetPagination();
      // remove from store
      this.removeFilterByName(name);
      this.removePaginationByName(name);
      this.removeSortByName(name);
      // clear the sortBy flag
      this.$refs[this.tableRef].sortBy = "";
      this.$refs[this.tableRef].sortDesc = false;
      // fetch data
      // // this.$refs[this.tableRef].fetch();
      // NOTE: since salesman_id is mandatory, cannot fetch (with no filter), but must clear items instead!
      // this.onSearch(name);
      // reset changedIds
      this.changedIds = [];
      // reset items
      this.$refs[this.tableRef].items = [];
      // reset checkAll checkbox
      this.$refs[this.tableRef].checkAll = false;
      // reset Sel.PDF checkbox
      this.uniquePdfIds = [];
      this.$refs[this.tableRef].myToggleUnique = false;
      //this.resetPage();
      // });
    },
    removeBrokerStatement(id) {
      console.debug("Deleting broker_statement: ", id);

      this.isSaving = true;
      const Repo = RepositoryFactory.get(this.repository);
      Repo.destroy(id)
        .then(() => {
          this.isSaving = false;
          // this.$refs[this.tableRef].fetch();
          this.onSearch(this.filterName);
          this.$showSnackbar({
            preset: "success",
            text: "Rendiconto eliminato",
          });
        })
        .catch((error) => {
          let errMsg = this.$getErrorMessage(error);
          this.$showSnackbar({
            preset: "error",
            text: `${errMsg}`,
          });
          this.isSaving = false;
        });
    },
    downloadReport(document) {
      this.downloadDocument(document);
    },
    onSend() {
      this.isLoading = true;
      let RepoLC = RepositoryFactoryLC.get("email");
      RepoLC.start(this.form)
        .then(() => {
          /* Aggiungi il "togli spunta a tutte" una volta finito di inviare i rendiconti */
          this.filterUpdate("toglispunta");
          /* END */
          this.$showSnackbar({
            preset: "success",
            text: "E-Mail inviate",
          });
        })
        .catch((error) => {
          let errMsg = `Error ${error.code}: ${error.message}`; // this.$getErrorMessage(error);
          this.$showSnackbar({
            preset: "error",
            text: errMsg,
          });
        })
        .finally(() => {
          this.$bvModal.hide(this.modalRef);
          this.isLoading = false;
        });
    },
    // onGenerate(form) {
    //   this.$bvModal.hide(this.generateBrokerStatementModalRef);

    //   const Repo = RepositoryFactory.get("book_entry");

    //   if (this.mode === "commission_mode") {
    //     form["no_statement"] = "Y";
    //   } else {
    //     form["no_statement"] = "N";
    //   }

    //   Repo.generate_broker_statements(form)
    //     .then(() => {
    //       this.$showSnackbar({
    //         preset: "success",
    //         text: "Processo di generazione dei rendiconti avviato",
    //       });
    //     })
    //     .catch((error) => {
    //       let errMsg = this.$getErrorMessage(error);
    //       this.$showSnackbar({
    //         preset: "error",
    //         text: `${errMsg}`,
    //       });
    //     });
    // },
    onGenerateUniquePdf() {
      if (!this.uniquePdfIds.length) {
        this.$showSnackbar({
          preset: "info",
          text: "Nessun rendiconto selezionato",
        });
        return;
      }
      let code = "AGRENPROV";
      this.onExport("pdf", code)
        .then(() => {})
        .catch((error) => {
          let errMsg = this.$getErrorMessage(error);
          this.$showSnackbar({
            preset: "error",
            text: errMsg,
          });
        });
    },
    onSelectAll() {
      this.filterUpdate("spunta");
    },
    onUnselectAll() {
      this.filterUpdate("toglispunta");
    },
    filterUpdate(mode) {
      this.isLoadingSpunte = true;
      let filter;
      let qs = {};
      let payload = {
        is_selected: null,
      };
      let tableRef = this.$refs[this.tableRef];
      switch (mode) {
        case "spunta":
          payload.is_selected = "Y";
          filter = tableRef.loadFilter(tableRef.filterName);
          if (filter) {
            qs.filter = filter;
          }
          break;
        case "toglispunta":
          payload.is_selected = "N";
          // qs.filterOn = tableRef.prepareFilterQueryString({
          //   byAttribute: { sent: "N" },
          // });
          break;

        default:
          break;
      }
      let Repo = RepositoryFactory.get(this.repository);
      tableRef.isLoading = true;
      this.isLoadingSpunte = true;
      let queryString = Object.values(qs).join("&");
      Repo.filter_update(payload, queryString)
        .then(() => {
          // do not fetch, just loadSelectedCounter()
          return tableRef
            .loadSelectedCounter()
            .then(() => {
              // then set all checkboxes of all items in this page
              tableRef.items.forEach((item) => {
                item.is_selected.value = payload.is_selected;
                item.is_selected.text =
                  payload.is_selected == "Y" ? "Si" : "No";
              });
              tableRef.isLoading = false;
              this.isLoadingSpunte = false;
              this.$showSnackbar({
                preset: "success",
                text: `Spunta ${
                  mode == "spunta" ? "aggiunta" : "tolta"
                } con successo`,
              });
            })
            .catch((error) => {
              let errMsg = this.$getErrorMessage(error);
              this.$showSnackbar({
                preset: "error",
                text: errMsg,
              });
            });
        })
        .catch((error) => {
          this.isLoading = false;
          let errMsg = this.$getErrorMessage(error);
          this.$showSnackbar({
            preset: "error",
            text: `${errMsg}`,
          });
        })
        .finally(() => {
          tableRef.isLoading = false;
          this.isLoadingSpunte = false;
        });
    },
    onUpdateSelected(row) {
      this.updateSelected(row);
    },
    updateSelected(row) {
      let queryString = `byAttribute[id]=${row.id}`;
      let payload = {
        is_selected: row.is_selected.value,
      };
      let tableRef = this.$refs[this.tableRef];
      let Repo = RepositoryFactory.get(this.repository);
      tableRef.isLoading = true;
      Repo.filter_update(payload, queryString)
        .then(() => {
          this.$showSnackbar({
            preset: "success",
            text: `Aggiornato con successo`,
          });
          // do not fetch, just loadSelectedCounter()
          tableRef
            .loadSelectedCounter()
            .then(() => {
              tableRef.isLoading = false;
            })
            .catch((error) => {
              tableRef.isLoading = false;
              let errMsg = this.$getErrorMessage(error);
              this.$showSnackbar({
                preset: "error",
                text: errMsg,
              });
            });
        })
        .catch((error) => {
          this.isLoading = false;
          let errMsg = this.$getErrorMessage(error);
          this.$showSnackbar({
            preset: "error",
            text: `${errMsg}`,
          });
        });
    },
    addToUniquePdfIds(id) {
      // add to global list
      if (this.uniquePdfIds.indexOf(id) === -1) {
        this.uniquePdfIds.push(id);
      }
    },
    removeFromUniquePdfIds(id) {
      let index = this.uniquePdfIds.indexOf(id);
      if (index !== -1) {
        this.uniquePdfIds.splice(index, 1);
      }
    },
    manipolaItems(data) {
      // add fake field "uniquePdfRow"
      data.forEach((item) => {
        this.$set(item, "uniquePdfRow", false);
      });
      return data;
    },
    onUnique(item) {
      if (item.uniquePdfRow) {
        // checked..
        this.addToUniquePdfIds(item.id);
      } else {
        // unchecked
        this.removeFromUniquePdfIds(item.id);
      }
    },
    onUniqueSelectAll() {
      let extendedData = this.$refs[this.tableRef].items.map((obj) => ({
        ...obj,
        uniquePdfRow: true,
      }));
      this.$refs[this.tableRef].items = extendedData;
      // add all ids
      this.uniquePdfIds = this.$refs[this.tableRef].items.map((e) => e.id);
    },
    retriveActiveFilters(obj = this.filter, parentKey = "") {
      for (const key in obj) {
        const value = obj[key];
        // Build the property path (for nested properties)
        const fullPath = parentKey ? `${parentKey}.${key}` : key;

        if (key === "byCustom" && typeof value === "object") {
          // Special handling for `byCustom`: Return everything in the inner object only if `value` is not null
          for (const innerKey in value) {
            const innerValue = value[innerKey];
            if (
              innerValue &&
              typeof innerValue === "object" &&
              "value" in innerValue
            ) {
              /* By default "value" is euqal to `null`, after it's been filled and being consequently emptied it's equal to an empty string */
              if (!(innerValue.value === null || innerValue.value === "")) {
                this.activeFilters[`${fullPath}.${innerKey}.value`] =
                  innerValue.value;
              }
            }
          }
        } else if (value && Array.isArray(value)) {
          if (value.length === 1) {
            this.activeFilters[fullPath] = value[0];
          } else if (value.length > 1) {
            // If it's an array don't print all the values recorsively
            this.activeFilters[fullPath] = `${value.length} selezioni`;
          }
        } else if (value && typeof value === "object") {
          // Recursively process nested objects for non-`byCustom` keys
          Object.assign(
            this.activeFilters,
            this.retriveActiveFilters(value, fullPath),
          );
        } else if (value !== null && String(value).length) {
          // Append non-null values
          this.activeFilters[fullPath] = value;
        }
      }
      return this.activeFilters;
    },
    onUniqueDeselectAll() {
      let extendedData = this.$refs[this.tableRef].items.map((obj) => ({
        ...obj,
        uniquePdfRow: false,
      }));
      this.$refs[this.tableRef].items = extendedData;
      // reset all ids
      this.uniquePdfIds = [];
    },
    ...mapActions("filters", {
      saveFilterByName: "saveByName",
      removeFilterByName: "removeByName",
    }),
    ...mapActions("pagination", {
      removePaginationByName: "removeByName",
      savePaginationByName: "saveByName",
    }),
    ...mapActions("sorts", {
      removeSortByName: "removeByName",
    }),
    ...mapGetters("auth", {
      getSalesmen: "salesmen",
      getSalesmenOrderedByCode: "salesmen_orderd_by_code",
    }),
  },
  beforeMount() {
    this.isLoading = true;
    this.salesmen = this.getSalesmen();
    this.salesmen_ordered = this.getSalesmenOrderedByCode();
    this.salesmen_select = this.salesmen;
    // do not AUTOMATIC FETCH
    this.removeFilterByName(this.filterName);
    // // also load counter
    // this.$refs[this.tableRef].loadSelectedCounter();
    // carico i template lisacomunica email
    const RepoLC = RepositoryFactoryLC.get("email");
    // filtrare per tipo 'Rendiconto'
    RepoLC.index("type=REN_PRO")
      .then((response) => {
        console.log("email", response.data.content);
        this.email_templates = response.data.content.map((e) => {
          return { value: e.id, text: e.title };
        });
      })
      .catch((error) => {
        let errMsg = this.$getErrorMessage(error);
        this.$showSnackbar({
          preset: "error",
          text: errMsg,
        });
      })
      .finally(() => {
        this.isLoading = false;
      });
  },
  mounted() {
    // also load counter
    this.$refs[this.tableRef].loadSelectedCounter();
  },
  computed: {
    countActiveFilters() {
      console.log("COUNT ACT FILTERS", Object.keys(this.activeFilters));
      return Object.keys(this.activeFilters).length;
    },
    computedFilterTitle() {
      return `Filtri${
        this.countActiveFilters ? ` (${this.countActiveFilters})` : ""
      }`;
    },
    flds() {
      return this.selectableFields[
        this.$store.state.auth.settings.attribute_STATMANB_value
      ];
    },
    lscmnc() {
      return this.form;
    },
  },
};
</script>
